import { create } from 'zustand';

const useAppStore = create((set) => ({
  initialized: false,
  locale: 'en-US',

  setInitialized: (initialized) => set({ initialized }),
  setLocale: (locale) => set({ locale }),
  resetAppState: () =>
    set({
      initialized: false,
      locale: 'en-US',
    }),
}));

export default useAppStore;
